import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { IMAGES, QUOTE } from "../lib/site";
import { useSite, siteImg } from "../context/SiteContext";

export const QuoteBanner = () => {
  const site = useSite();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1.15, 1]);

  return (
    <section ref={ref} data-testid="quote-banner" className="relative h-[70vh] min-h-[480px] overflow-hidden flex items-center">
      <motion.img
                  style={{ scale }}
                  src={siteImg(site, "quote", IMAGES.colorPortrait)}
        alt="Akalibe"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-black/55" />
      <div className="absolute inset-0 bg-gradient-to-r from-base/90 via-base/30 to-transparent" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 w-full">
        <motion.blockquote
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          className="max-w-2xl"
        >
          <span className="font-serif text-gold text-6xl leading-none">“</span>
          <p className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-white -mt-4">
            {QUOTE}
          </p>
          <cite className="not-italic block text-sm uppercase tracking-[0.3em] text-gold mt-8">Akalibe</cite>
        </motion.blockquote>
      </div>
    </section>
  );
};
